// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"4cd90c56","453":"a404d38f"}[chunkId] + ".chunk.js";
};